.counterBeforeChevron {
  margin-left: 8px;
}
